module.exports = " <img :src=defaultSrc class=vux-x-img :class=class /> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/x-img/index.vue
// module id = 264
// module chunks = 2